import React, { useEffect, useState } from 'react';
import { db } from '../../../../firebase';
import { collection, getCountFromServer, query, where } from 'firebase/firestore';
import { useAuth } from '../../../../context/AuthContext';

const BookedUnit = ({ propID, towerID, unitID }) => {

  const { user } = useAuth();
  const { bid } = user.claims;

  const [count, setCount] = useState(0);

  async function getBookedUnits(propID, towerID) {
    const coll = collection(db, "Businesses", bid, "Properties", propID, "BookedUnits");
    const q = query(coll, where("towerID", "==", towerID), where("unitID", "==", unitID));
    const snapshot = await getCountFromServer(q);
    setCount(snapshot.data().count);
  }

  useEffect(() => {
    getBookedUnits(propID, towerID);
  }, [])

  return count;
}

export default BookedUnit;
